import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Produk from "@/pages/Produk";
import Gudang from "@/pages/Gudang";
import StokMasuk from "@/pages/StokMasuk";
import Transfer from "@/pages/Transfer";
import TransferDetail from "@/pages/TransferDetail";
import Penjualan from "@/pages/Penjualan";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Receivables from "@/pages/Receivables";
import Customers from "@/pages/Customers";
import StockCheck from "@/pages/StockCheck";
import Laporan from "@/pages/Laporan";
import Pengguna from "@/pages/Pengguna";

function Loading() {
  return (
    <div className="grid min-h-screen place-items-center bg-background">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-300 border-t-blue-600" data-testid="app-loading" />
    </div>
  );
}

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

const GUDANG = ["owner", "branch_manager", "admin_gudang"];
const TOKO = ["owner", "branch_manager", "admin_toko"];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="produk" element={<Produk />} />
            <Route path="gudang" element={<Protected roles={GUDANG}><Gudang /></Protected>} />
            <Route path="stok-masuk" element={<Protected roles={GUDANG}><StokMasuk /></Protected>} />
            <Route path="transfer" element={<Protected roles={GUDANG}><Transfer /></Protected>} />
            <Route path="transfer/:id" element={<Protected roles={GUDANG}><TransferDetail /></Protected>} />
            <Route path="penjualan" element={<Protected roles={TOKO}><Penjualan /></Protected>} />
            <Route path="penjualan/:id" element={<Protected roles={TOKO}><InvoiceDetail /></Protected>} />
            <Route path="piutang" element={<Protected roles={TOKO}><Receivables /></Protected>} />
            <Route path="customers" element={<Protected roles={TOKO}><Customers /></Protected>} />
            <Route path="stok-check" element={<StockCheck />} />
            <Route path="laporan" element={<Laporan />} />
            <Route path="pengguna" element={<Protected roles={["owner"]}><Pengguna /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
